module.exports = __webpack_public_path__ + "5951c1d8ae8eb5ac0163d7324bd74485.svg";